/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipologiaPratica } from './tipologia-pratica';


export interface ServiziListFilter { 
    q?: string;
    tipo_servizio?: ServiziListFilterTipoServizioEnum;
    comune_id?: string;
    tipo_pratica_id?: string;
    tipologia_pratica?: TipologiaPratica;
    stato?: ServiziListFilterStatoEnum;
    include_chiusi?: boolean;
}
export enum ServiziListFilterTipoServizioEnum {
    MENSA = 'MENSA'
};
export enum ServiziListFilterStatoEnum {
    ATTIVO = 'ATTIVO',
    FUTURO = 'FUTURO',
    SCADUTO = 'SCADUTO',
    TUTTI = 'TUTTI'
};



